export const FontType = {
  PRIMARY: "'NunitoVariable', sans-serif",
};

export const FontSize = {
  XXXS: '8px',
  XXS: '10px',
  XS: '12px',
  S: '14px',
  M: '16px',
  L: '18px',
  XL: '21px',
  XXL: '24px',
  XXXL: '28px',
  XXXXL: '36px',
  XXXXXL: '42px',
  HUGE: '60px',
};

export const FontWeight = {
  THIN: '300',
  REGULAR: '400',
  BOLD: '700',
  EXTRABOLD: '800',
  BLACK: '900',
};
